import type { Blocker } from 'react-router'
import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import { cloneDeep, isEqual } from 'lodash'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import { type CampaignViewStore } from 'pages/campaigns/ui/CampaignView/store/CampaignViewStore'

export class CampaignBlockerStore {
  _cacheParams
  constructor(private campaignViewStore: CampaignViewStore) {
    this._cacheParams = cloneDeep(campaignViewStore.params)
    makeAutoObservable(this)
  }

  get isExistChanges() {
    return !isEqual(this._cacheParams, this.campaignViewStore.params)
  }
  _modalId = nanoid()

  updateCache = () => {
    this._cacheParams = cloneDeep(this.campaignViewStore.params)
  }

  handleShowBlockerModal = (blocker: Blocker) => {
    if (blocker.state !== 'blocked') return

    const onNext = () => {
      const path = blocker.location.pathname
      blocker.proceed()

      uiStore.setRoutesBlocker(null)
      uiStore.changeRoute({
        path,
        type: 'vue',
        method: 'replace',
      })
      modalStore.closeModal(this._modalId)
    }

    const { status, isActive } = this.campaignViewStore

    const config = isActive
      ? { text: 'Publish changes', action: () => this.campaignViewStore.onPublish(true) }
      : status === null
      ? { text: 'Save as draft', action: this.campaignViewStore.onSaveDraft }
      : { text: 'Save changes', action: this.campaignViewStore.onSaveDraft }

    modalStore.addModal({
      id: this._modalId,
      type: ModalTypeList.WARNING,
      title: `${isActive ? 'Publish changes' : 'Save'} campaign before closing?`,
      primaryAction: {
        text: config.text,
        onAction: async () => {
          try {
            await config.action()
            onNext()
          } catch (e) {
            logger.error(e)
            modalStore.closeModal(this._modalId)
          }
        },
      },
      additionalSecondaryAction: {
        text: `${isActive ? 'Don’t publish' : 'Don’t save'}`,
        onAction: onNext,
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(this._modalId)
        },
      },
    })
  }
}
